import { cardRoutesDictionary } from './card-routes.dictionary.ts';
import type { RouteRecordRaw } from 'vue-router';
import { CREATE_ORDER_WIZARD_NAMESPACE } from '../pages/CreateOrder/create-order-wizard.ts';

export const cardRoutesConfig: RouteRecordRaw = {
  ...cardRoutesDictionary.card.root,
  redirect: { name: cardRoutesDictionary.card.cardRoot.name },
  children: [
    {
      ...cardRoutesDictionary.card.cardList,
      component: () => import('../pages/CardListPage/CardListPage.vue'),
    },
    {
      ...cardRoutesDictionary.card.cardOrderslist,
      component: () =>
        import('../pages/CardOrdersListPage/CardOrdersListPage.vue'),
    },
    {
      ...cardRoutesDictionary.card.cardOrdersDetail,
      props: true,
      component: () =>
        import(
          '../pages/CardOrdersListPage/CardOrderDetailPage/CardOrderDetailPage.vue'
        ),
    },
    {
      ...cardRoutesDictionary.card.cardRoot,
      redirect: { name: cardRoutesDictionary.card.cardList.name },
    },

    {
      ...cardRoutesDictionary.card.create,
      meta: {
        wizardNamespace: CREATE_ORDER_WIZARD_NAMESPACE,
        wizardExitRoute: cardRoutesDictionary.card.cardOrderslist.name,
      },
      component: () => import('../pages/CreateOrder/CreateOrderWizardPage.vue'),
    },
  ],
};
